import React, { useState } from "react";
import arrowIcon from "../../assets/down-arrow.png";
import { useTranslation } from "react-i18next";

// Add content type constants
export const CARD_CONTENT_TYPES = {
  TEXT: "text",
  ELEMENT: "element",
  MONEY: "money",
  LINK: "link",
  EDITABLE: "editable",
  SECTION_HEADER: "section-header",
};

const CollapsibleCard = ({
  title,
  content,
  body,
  footerContent,
  className = "",
  isEditing,
  collapsed = true,
  toggleCollapsed,
}) => {
  // Hooks
  const { t } = useTranslation("general");

  // State
  const [isCollapsed, setIsCollapsed] = useState(collapsed);

  const handleToggle = () => {
    setIsCollapsed((prev) => !prev);
    toggleCollapsed?.((prev) => !prev);
  };

  const renderContent = (contentItem) => {
    switch (contentItem.type) {
      case CARD_CONTENT_TYPES.SECTION_HEADER:
        return contentItem.element;
      case CARD_CONTENT_TYPES.TEXT:
        return (
          <div className="t-text-normal u-padding--bottom_100 u-margin_0 o-row">
            <span className="u-width-specific_150">{contentItem.title}: </span>
            <span>{contentItem.value}</span>
          </div>
        );
      case CARD_CONTENT_TYPES.MONEY:
        return <span className="t-text-normal">{contentItem.value}</span>;
      case CARD_CONTENT_TYPES.LINK:
        return (
          <a href={contentItem.to} className="t-body-text">
            {contentItem.value}
          </a>
        );

      case CARD_CONTENT_TYPES.EDITABLE:
        return (
          <div className="t-text-normal u-padding--bottom_100 u-margin_0 o-row u-width_full-width">
            {!isEditing ? (
              <>
                <span className="u-width-specific_150">
                  {contentItem.title}:{" "}
                </span>
                <span>{contentItem.value}</span>
              </>
            ) : (
              contentItem.element
            )}
          </div>
        );
      case CARD_CONTENT_TYPES.ELEMENT:
        return contentItem.value;
      default:
        return contentItem.value;
    }
  };

  return (
    <div
      className={`c-collapsible-card ${className} ${
        isCollapsed ? "" : "open u-height_full-height"
      }`}
    >
      {/* Header */}
      <div
        className="c-collapsible-card-header o-row o-row--horizontal-align_space-between o-row--vertical-align_center"
        onClick={handleToggle}
      >
        <span className="t-bold_bold">{title}</span>
        <button
          className="collapsible-button o-row o-row--vertical-align_center o-row--gap-size_200 t-bold_bold t-text-mini"
          type="button"
        >
          <img src={arrowIcon} alt="Toggle" className="c-collapsible-arrow" />
          {isCollapsed ? `${t("show")}` : `${t("hide")}`}
        </button>
      </div>

      {/* Body */}
      {!isCollapsed && (
        <div className="u-padding-left_400 u-padding-right_400 o-column u-padding--top_400 o-column--horizontal-align_space-between u-height_full-height">
          {body ? (
            <>{body}</>
          ) : (
            <div>
              {Array.isArray(content)
                ? content.map((item, index) => (
                    <div key={index} className="o-row o-row--gap-size_300">
                      {renderContent(item)}
                    </div>
                  ))
                : renderContent(content)}
            </div>
          )}

          {/* Footer */}
          {footerContent && (
            <div className="u-margin--top_200">{footerContent}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default CollapsibleCard;
